//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'CPOT',
  data() {
    return {
      defaultJson:{
        "Body2 (short)": "Restlessness",
        "Compliance1 (short)": "Coughing",
        "Body0": "Does not move at all (does not necessarily mean absence of pain)",
        "Facial2": "All of the above facial movements plus intubatedlid tightly closed",
        "Muscle2 (short)": "Very tense\/rigid",
        "Body0 (short)": "Absence of movements",
        "Compliance0 (short)": "Tolerating",
        "Facial1 (short)": "Tense",
        "ComplianceTitle": "Compliance with Ventilator",
        "Muscle1 (short)": "Tense, rigid",
        "Muscle0": "No resistance to passive movements",
        "Compliance2": "Asynchrony: blocking ventilation, alarms frequently activated",
        "Compliance1": "Coughing, but alarms stop spontaneously",
        "Compliance0": "Alarms not activated, easy ventilation: tolerating ventilator or movement",
        "Body1 (short)": "Protection",
        "Facial0 (short)": "Relaxed, neutral",
        "Muscle1": "Resistance to passive movements",
        "Body2": "Pulling tube, attempting to sit up, moving limbs\/ thrashing, not following commands, striking at staff, trying to climb out of bed",
        "Facial0": "No muscular tension observed",
        "Muscle0 (short)": "Relaxed",
        "BodyTitle": "Body Movements",
        "Muscle2": "Strong resistance to passive movements, inability to complete them",
        "FacialTitle": "Facial Expression",
        "Body1": "Slow, cautious movements, touching or rubbing the pain site, seeking attention through movements",
        "Compliance2 (short)": "Fighting",
        "Facial1": "Presence of frowning, brow lowering, orbit tightening and levator contraction",
        "Facial2 (short)": "Grimacing",
        "MuscleTitle": "Muscle Tension"
      },
      form:{
        intubated:'0',
        facial:'',
        body:'',
        muscle:'',
        compliance:'',
        vocalization:''
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'有肌肉紧张'},
        {value:"1",name:'皱眉，眉毛低，眼眶紧，提肌紧张'},
        {value:"2",name:'以上所有面部表情运动及眼睑紧闭'},
      ],
      dataList2:[
        {value:"0",name:'完全不动（但不意味没有疼痛）'},
        {value:"1",name:'缓慢、小心的移动，触摸、揉搓疼痛部位，通过移动吸引他人注意力'},
        {value:"2",name:' 拉扯插管，尝试坐起来，移动四肢/剧烈扭动，不遵从指挥，打人，尽力从床上爬出来'},
      ],
      dataList3:[
        {value:"0",name:'被动移动时无阻力'},
        {value:"1",name:'被动移动时有阻力'},
        {value:"2",name:'被动移动时阻力强， 不能完成'},
      ],
      dataList4:[
        {value:"0",name:'未触发警报，可耐受呼吸机及移动'},
        {value:"1",name:'咳嗽，但警报可自发停止'},
        {value:"2",name:'人机不同步，通气阻断，警报经常激发'},
      ],
      dataList5:[
        {value:"0",name:'用正常语调说话或者不说话'},
        {value:"1",name:'叹气，呻吟'},
        {value:"2",name:'大声哭喊，啜泣'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    
    maxNSum(num, obj ){
      let self = this
      

    },

  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form.intubated=='1') {
        form.vocalization = '0'
      } else if(form.intubated=='0') {
        form.compliance='0'
      }
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // facial + body + muscle + (intubated ? compliance : vocalization)
        let result = form.facial + form.body + form.muscle + (form.intubated ? form.compliance : form.vocalization)
        self.hasScore = true
        return String(result)
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/CPOT.vue